/*
 * rheincool — Akkordeon (Komponenten-Katalog 4.5)
 * <rc-accordion> mit [data-accordion-toggle] + [data-accordion-panel]:
 * aria-expanded, Enter/Space (native button), Chevron dreht via CSS.
 * Mehrere Toggle/Panel-Paare pro Element möglich (FAQ-Listen).
 *
 * Die Datei wird von drei Sections eingebunden (product-faq,
 * product-spec-highlights, article-faq). Stehen zwei davon auf derselben
 * Seite, laeuft das Skript zweimal — dann warf `class RcAccordion` einen
 * SyntaxError „already declared" und der zweite Durchlauf brach ab. Deshalb
 * der Guard: das Modul definiert sich genau einmal.
 */
if (!customElements.get('rc-accordion')) {
class RcAccordion extends HTMLElement {
  connectedCallback() {
    this.bindeToggles();
    this.oeffneBeiSprung();
    // Der Hash kann sich ohne Neuladen aendern (Klick auf einen Link, der
    // schon auf der Seite steht) — dann erneut pruefen.
    this.beiHashwechsel = () => this.oeffneBeiSprung();
    window.addEventListener('hashchange', this.beiHashwechsel);
  }

  /*
    Sprungziel geoeffnet ausliefern.

    Wer aus der Kaufbox oder der Ankernavigation gezielt auf einen Abschnitt
    springt, will dessen Inhalt sehen. Bei den technischen Daten stand dort
    bisher nur ein zugeklappter Knopf — die Tabelle mit den tatsaechlichen
    Werten blieb verborgen, und weil der Abschnitt dadurch kurz ist, stand
    schon der naechste im Bild.

    Geoeffnet wird ausschliesslich, was `data-anchor-open` traegt. Die
    FAQ-Listen benutzen dasselbe Akkordeon und sollen zu bleiben.
  */
  oeffneBeiSprung() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var ziel;
    try {
      ziel = document.querySelector(hash);
    } catch (e) {
      return; // ungueltiger Selektor im Hash
    }
    if (!ziel) return;
    this.querySelectorAll('[data-anchor-open]').forEach((toggle) => {
      if (!ziel.contains(toggle) && ziel !== toggle) return;
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      // Ueber den echten Klick, damit Zustand, Panel und Klassen an genau
      // einer Stelle gesetzt werden — dem Handler unten.
      toggle.click();
    });
  }

  disconnectedCallback() {
    if (this.beiHashwechsel) window.removeEventListener('hashchange', this.beiHashwechsel);
  }

  bindeToggles() {
    this.querySelectorAll('[data-accordion-toggle]').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) return;
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        panel.hidden = expanded;
        toggle.closest('[data-accordion-item]')?.classList.toggle('is-open', !expanded);
        if (!expanded && window.rcTrack && toggle.dataset.faqQuestion) {
          window.rcTrack('faq_open', { question: toggle.dataset.faqQuestion });
        }
      });
    });
  }
}

  customElements.define('rc-accordion', RcAccordion);
}
